// extracted by mini-css-extract-plugin
export default {"collapseBtn":"style_collapseBtn__MO2JK","collapsed":"style_collapsed__fqcVd","firstCol":"style_firstCol__Hsz6j"};